import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Settings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/setting/get", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (this.isBlank(this.state.data.record.marginBottom)) this.state.data.record.marginBottom = 0;
        if (this.isBlank(this.state.data.record.marginRight)) this.state.data.record.marginRight = 0;
        if (this.isBlank(this.state.data.record.marginLeft)) this.state.data.record.marginLeft = 0;
        if (this.isBlank(this.state.data.record.marginTop)) this.state.data.record.marginTop = 0;
        
        this.state.data.record.marginBottom = parseInt(this.state.data.record.marginBottom);
        this.state.data.record.marginRight = parseInt(this.state.data.record.marginRight);
        this.state.data.record.marginLeft = parseInt(this.state.data.record.marginLeft);
        this.state.data.record.marginTop = parseInt(this.state.data.record.marginTop);

        e.preventDefault();
        this.httpPost("api/v1/setting/save", {
            marginBottom: this.state.data.record.marginBottom,
            marginRight: this.state.data.record.marginRight,
            marginLeft: this.state.data.record.marginLeft,
            marginTop: this.state.data.record.marginTop,
            notPrint: this.state.data.record.notPrint,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setNotPrint(e, f) {
        this.state.data.record.notPrint = this.state.data.record.notPrint.replace("[" + f + "]", "");
        if (e.target.checked)
            this.state.data.record.notPrint += "[" + f + "]";
    }
    checked(f) {
        return this.state.data.record.notPrint.includes("[" + f + "]");
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">تنظیمات</h5>
                                        </div>
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="pricing">

                                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">فاصله چاپ (بالا)</label>
                                                            <div className="form-control-wrap">
                                                                <input defaultValue={this.state.data.record.marginTop} onChange={e => this.state.data.record.marginTop = e.target.value} maxLength="13" className="form-control" type="text" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">فاصله چاپ (پایین)</label>
                                                            <div className="form-control-wrap">
                                                                <input defaultValue={this.state.data.record.marginBottom} onChange={e => this.state.data.record.marginBottom = e.target.value} maxLength="13" className="form-control" type="text" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">فاصله چاپ (چپ)</label>
                                                            <div className="form-control-wrap">
                                                                <input defaultValue={this.state.data.record.marginLeft} onChange={e => this.state.data.record.marginLeft = e.target.value} maxLength="13" className="form-control" type="text" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">فاصله چاپ (راست)</label>
                                                            <div className="form-control-wrap">
                                                                <input defaultValue={this.state.data.record.marginRight} onChange={e => this.state.data.record.marginRight = e.target.value} maxLength="13" className="form-control" type="text" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <input type="checkbox" onChange={e => this.setNotPrint(e, "characteristics")} defaultChecked={this.checked("characteristics")} /> وزن مخصوص
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <input type="checkbox" onChange={e => this.setNotPrint(e, "sg")} defaultChecked={this.checked("sg")} /> پاکی سنگ
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <input type="checkbox" onChange={e => this.setNotPrint(e,"ri")} defaultChecked={ this.checked("ri") } /> ضریب شکست
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}